import { RadioField, RadioInput } from '@flos/react-ui';
import type { AttributeChangeProps } from '../../../types';
import { useState } from 'react';
import { useHippoText } from '../../../../../hooks/useHippoText';
import type { AreaOfDestination_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';
import { getOPCCoverableAttributeSelector } from '../../../../../recoil/selectors/getOPCCoverableAttributeSelector';
import { getCoverableInfoSelector } from '../../../../../recoil/selectors/getCoverableInfoSelector';

const ChangeAreaOfDestination = ({
    updateCoverableAttribute
}: AttributeChangeProps): React.JSX.Element => {
    const coverable = useRecoilValue(getCoverableInfoSelector);
    const getHippoText = useHippoText();
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const currentOPCAttribute = useRecoilValue(getOPCCoverableAttributeSelector)?.travel
        ?.areaOfDestination;
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const destinationArea = coverable.isTravelWorldArea ? 'Worldwide' : 'OnlyEurope';
    const [areaOfDestination, setAreaOfDestination] = useState<string>(
        currentOPCAttribute ?? destinationArea
    );

    const hippoText = {
        worldWideOption: getHippoText('DSS-COVERAGE-PACKAGE-PAGE-WORLDWIDE'),
        europeOnlyOption: getHippoText('DSS-COVERAGE-PACKAGE-PAGE-EUROPE-ONLY')
    };

    const handleAreaOfDestinationChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = event.target;
        updateCoverableAttribute({
            areaOfDestination: value as AreaOfDestination_Top
        });
        setAreaOfDestination(value as AreaOfDestination_Top);
        setIsOpcDataFilled(value !== destinationArea);
    };

    return (
        <div>
            <RadioField
                value={areaOfDestination}
                onChange={handleAreaOfDestinationChange}
                disabled={isOpcFetching}
            >
                <RadioInput value="Worldwide" label={hippoText.worldWideOption} />
                <RadioInput value="OnlyEurope" label={hippoText.europeOnlyOption} />
            </RadioField>
        </div>
    );
};

export default ChangeAreaOfDestination;
